import utils from "./utils.js";

const DEFAULT_ACCENT = "#3ED3E0";
const DEFAULT_TEXT = "#545383";
const DEFAULT_BACKGROUND = "#FFFFFF";

function hexToRgb(hex) {
  let value = hex.replace("#", "");
  if (value.length === 3) {
    value = value
      .split("")
      .map((c) => c + c)
      .join("");
  }
  let n = parseInt(value.slice(0, 6), 16);
  return [(n >> 16) & 255, (n >> 8) & 255, n & 255];
}

function isHex(color) {
  return /^#([0-9a-f]{3}|[0-9a-f]{6})$/i.test(color || "");
}

// Moves `from` towards `to` by `weight` (0..1)
export function mix(from, to, weight) {
  let a = hexToRgb(from);
  let b = hexToRgb(to);
  return (
    "#" +
    a
      .map((c, i) =>
        Math.round(c + (b[i] - c) * weight)
          .toString(16)
          .padStart(2, "0")
      )
      .join("")
  );
}

export function rgba(hex, alpha) {
  let [r, g, b] = hexToRgb(hex);
  return `rgba(${r}, ${g}, ${b}, ${alpha})`;
}

// Derives the signup card colors (surface, filled inputs, borders, muted text)
// from the three colors a merchant configures in their branding.
export function buildPalette(branding) {
  let accent = isHex(branding?.accentColor)
    ? branding.accentColor
    : DEFAULT_ACCENT;
  let text = isHex(branding?.secondaryColor)
    ? branding.secondaryColor
    : DEFAULT_TEXT;
  let background = isHex(branding?.backgroundColor)
    ? branding.backgroundColor
    : DEFAULT_BACKGROUND;
  let dark = utils.colorIsDark(background);
  let surface = dark ? mix(background, "#FFFFFF", 0.06) : "#FFFFFF";
  // Merchants picked text and accent to stand out on their page background,
  // but cards sit on `surface`. White text on a pastel page would vanish on
  // a white card, so those fall back to readable ink.
  text = utils.getContrastColor(surface, text);
  accent = [accent, text].find(
    (color) => utils.getContrastRatio(surface, color) >= 1.5
  );
  return {
    dark,
    accent,
    text,
    background,
    surface,
    field: mix(surface, text, 0.04),
    line: mix(surface, text, 0.15),
    muted: mix(text, surface, 0.25),
    onAccent: utils.colorIsDark(accent) ? "#FFFFFF" : "#000000",
    ring: rgba(accent, 0.22),
  };
}
